import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _isNumber from 'lodash/isNumber';
import { DEFAULT_PAGE_SIZE } from '@tekion/tekion-base/constants/tableConstants';
import Pagination from '../../organisms/Pagination';
import { DEFAULT_RESULTS_PER_PAGE_OPTIONS } from './constants/table.constants';
var TablePagination = /*#__PURE__*/function (_React$Component) {
  _inherits(TablePagination, _React$Component);
  var _super = _createSuper(TablePagination);
  function TablePagination() {
    var _this;
    _classCallCheck(this, TablePagination);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "setPage", function (totalPages, resultsPerPage) {
      return function (page) {
        var changePage = _this.props.changePage;
        var isPageInValid = page > totalPages || page < 1;
        var newPage = isPageInValid ? totalPages : page;
        changePage({
          page: newPage,
          resultsPerPage: resultsPerPage
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setResultsPerPage", function (resultsPerPage) {
      var _this$props = _this.props,
        prevResultsFromPage = _this$props.resultsPerPage,
        totalNumberOfEntries = _this$props.totalNumberOfEntries,
        currentPage = _this$props.currentPage;
      if (resultsPerPage === prevResultsFromPage) return;
      if (!_isNumber(totalNumberOfEntries)) return;
      var newTotalPages = Math.ceil(totalNumberOfEntries / resultsPerPage);
      _this.setPage(newTotalPages, resultsPerPage)(currentPage);
    });
    return _this;
  }
  _createClass(TablePagination, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        initialFetchDone = _this$props2.initialFetchDone,
        isLoading = _this$props2.isLoading,
        currentPage = _this$props2.currentPage,
        resultsPerPage = _this$props2.resultsPerPage,
        pagerSize = _this$props2.pagerSize,
        canSetResultsPerPage = _this$props2.canSetResultsPerPage,
        displayFirstLast = _this$props2.displayFirstLast,
        resultsPerPageOptions = _this$props2.resultsPerPageOptions,
        fixedPagination = _this$props2.fixedPagination,
        className = _this$props2.className;
      var totalPages = this.state.totalPages;
      return /*#__PURE__*/React.createElement(Pagination, {
        displayFirstLast: displayFirstLast,
        pagerSize: pagerSize,
        resultsPerPageOptions: resultsPerPageOptions,
        canSetResultsPerPage: canSetResultsPerPage,
        resultsPerPage: resultsPerPage,
        initialFetchDone: initialFetchDone,
        isLoading: isLoading,
        setResultsPerPage: this.setResultsPerPage,
        changePage: this.setPage(totalPages, resultsPerPage),
        totalPages: totalPages,
        currentPage: currentPage,
        fixedPagination: fixedPagination,
        className: className
      });
    }
  }]);
  return TablePagination;
}(React.Component);
_defineProperty(TablePagination, "getDerivedStateFromProps", function (props) {
  var totalNumberOfEntries = props.totalNumberOfEntries,
    resultsPerPage = props.resultsPerPage,
    totalNumberOfPages = props.totalNumberOfPages;
  var totalPages = totalNumberOfPages || Math.ceil(totalNumberOfEntries / resultsPerPage);
  return {
    totalPages: totalPages
  };
});
TablePagination.propTypes = {
  totalNumberOfEntries: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  pagerSize: PropTypes.number,
  initialFetchDone: PropTypes.bool,
  isLoading: PropTypes.bool,
  displayFirstLast: PropTypes.bool,
  resultsPerPage: PropTypes.number,
  canSetResultsPerPage: PropTypes.bool,
  resultsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  fixedPagination: PropTypes.bool,
  className: PropTypes.string,
  totalNumberOfPages: PropTypes.number
};
TablePagination.defaultProps = {
  canSetResultsPerPage: true,
  displayFirstLast: true,
  isLoading: false,
  initialFetchDone: true,
  pagerSize: 5,
  resultsPerPage: DEFAULT_PAGE_SIZE,
  resultsPerPageOptions: DEFAULT_RESULTS_PER_PAGE_OPTIONS,
  fixedPagination: false,
  className: '',
  totalNumberOfPages: 0
};
export default TablePagination;